<template>
    <v-app :style="cssProps">
        <loading fixed ref="loading">
            <v-layout>
                <router-view class="router-view"></router-view>
                <alert ref="alert" />
            </v-layout>
        </loading>
    </v-app>
</template>

<style>
    @import './assets/material_outline.css';
    @import './assets/application.css';
</style>

<script>
import Vue from 'vue'
import Loading from './components/Loading'
import Alert from './components/Alert'
import { events } from './plugins/events'
import { reduce } from 'lodash'

export default {
  components: { Loading, Alert },
  computed: {
    cssProps () {
      return reduce(this.$vuetify.theme, (acc, v, k) => {
        acc[`--${k}`] = v
        return acc
      }, {})
    }
  },
  methods: {
    loadingStart () {
      this.$refs.loading.start()
    },
    loadingDone () {
      this.$refs.loading.done()
    },
    alertShow (options) {
      this.$refs.alert.show(options)
    },
    alertDismiss () {
      this.$refs.alert.dismiss()
    }
  },
  created: function () {
    // Loading
    events.$on(['loadingStart', 'httpStart'], () => this.loadingStart())
    events.$on(['loadingDone', 'httpDone'], () => this.loadingDone())

    // Alert
    events.$on('alertShow', (options) => this.alertShow(options))
    events.$on('alertDismiss', () => this.alertDismiss())
  }
}

Vue.prototype.$loading = {
  start: () => events.$emit('loadingStart'),
  done: () => events.$emit('loadingDone')
}

Vue.prototype.$alert = {
  show: (options) => events.$emit('alertShow', options),
  dismiss: () => events.$emit('alertDismiss')
}

</script>
